import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Download, RotateCcw, Trash2 } from "lucide-react";
import { OrigemBadge, origemKey } from "./backupOrigem";
import { STATUS_META, fmtDate, fmtSize } from "./backupFormat";

export function BackupHistoryRow({ f, canDeleteBackup, actions, onRestore }) {
  const meta = STATUS_META[f.status] || STATUS_META.unknown;
  const Icon = meta.icon;
  const canDownload = f.status !== "error" && f.size_bytes > 0;
  const isSelected = actions.selected.has(f.filename);
  const isDeleting = actions.deleting === f.filename;
  const isRetrying = actions.retrying === f.filename;
  return (
    <tr className={`border-b hover:bg-slate-50/50 ${isSelected ? "bg-rose-50/40" : ""}`} data-testid={`backup-row-${f.filename}`}>
      {canDeleteBackup && (
        <td className="px-3 py-3">
          <Checkbox checked={isSelected} onCheckedChange={() => actions.toggleSelect(f.filename)}
            aria-label={`Selecionar ${f.filename}`} data-testid={`checkbox-${f.filename}`} />
        </td>
      )}
      <td className="px-4 py-3 font-mono text-xs">
        <div>{f.filename}</div>
        {f.empresa_nome && <div className="text-[10px] text-indigo-700 mt-0.5 font-sans font-semibold">{f.empresa_nome}</div>}
      </td>
      <td className="px-4 py-3 text-xs whitespace-nowrap">{fmtDate(f.modified_at)}</td>
      <td className="px-4 py-3 text-xs whitespace-nowrap">{fmtSize(f.size_bytes)}</td>
      <td className="px-4 py-3">
        <Badge className={`text-[10px] uppercase ${meta.color}`}><Icon className="w-3 h-3 mr-1" />{meta.label}</Badge>
        {f.error && <div className="text-[10px] text-rose-600 mt-1 max-w-[220px] truncate" title={f.error}>{f.error}</div>}
        {f.duration_seconds != null && f.status === "success" && <div className="text-[10px] text-slate-500 mt-1">{f.duration_seconds.toFixed(1)}s</div>}
      </td>
      <td className="px-4 py-3 text-xs" data-testid={`origem-${f.filename}`} data-origem={origemKey(f.source)}>
        <OrigemBadge source={f.source} />
      </td>
      <td className="px-4 py-3 text-right">
        <div className="flex gap-2 justify-end">
          <Button size="sm" variant="outline" onClick={() => actions.download(f.filename)} disabled={!canDownload}
            data-testid={`btn-download-${f.filename}`} className="h-8">
            <Download className="w-3.5 h-3.5 mr-1" />Baixar
          </Button>
          {canDownload && f.empresa_id && (
            <Button size="sm" variant="outline" onClick={() => onRestore(f)} data-testid={`btn-restore-${f.filename}`}
              className="h-8 border-amber-300 text-amber-700 hover:bg-amber-50">
              <RotateCcw className="w-3.5 h-3.5 mr-1" />Restaurar
            </Button>
          )}
          {canDeleteBackup && (
            <Button size="sm" variant="outline" onClick={() => actions.deleteBackup(f)} disabled={isDeleting}
              data-testid={`btn-delete-backup-${f.filename}`} className="h-8 border-rose-300 text-rose-700 hover:bg-rose-50">
              <Trash2 className={`w-3.5 h-3.5 mr-1 ${isDeleting ? "animate-pulse" : ""}`} />
              {isDeleting ? "Excluindo…" : "Excluir"}
            </Button>
          )}
          {canDeleteBackup && f.status === "error" && (
            <Button size="sm" variant="outline" onClick={() => actions.retryBackup(f)} disabled={isRetrying}
              data-testid={`btn-retry-backup-${f.filename}`} className="h-8 border-emerald-300 text-emerald-700 hover:bg-emerald-50">
              <RotateCcw className={`w-3.5 h-3.5 mr-1 ${isRetrying ? "animate-spin" : ""}`} />
              {isRetrying ? "Reprocessando…" : "Retry"}
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
}
